import {normalizeActionHandlers} from './normalizeActionHandlers';
import {memoize} from '@servicenow/ui-internal';

export const normalizeBehaviors = memoize(normalizeBehaviorsInner, {
	profileName: 'normalizeBehaviors',
	createCacheKey: (b, t) => t
});

function normalizeBehaviorsInner(behaviors = [], tagName) {
	const {length: behaviorsCount} = behaviors;
	const normalizedBehaviors = [];
	for (let i = 0; i < behaviorsCount; i++) {
		const {behavior, options = {}} = behaviors[i] || {};
		const resolvedBehavior = behavior || behaviors[i] || {};
		const {name} = resolvedBehavior;
		const {initialState = {}, actionHandlers, eventHandlers = [], actions} = resolvedBehavior;

		normalizedBehaviors[i] = {
			behavior: {
				...resolvedBehavior,
				actionHandlers: normalizeActionHandlers(actionHandlers, tagName),
				initialState,
				eventHandlers,
				actions,
				options
			},
			name
		};
	}

	return normalizedBehaviors;
}
